import { render, staticRenderFns } from "./tracking-orders.vue?vue&type=template&id=79ae6384&scoped=true"
import script from "./tracking-orders.vue?vue&type=script&lang=js"
export * from "./tracking-orders.vue?vue&type=script&lang=js"
import style0 from "./tracking-orders.vue?vue&type=style&index=0&id=79ae6384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae6384",
  null
  
)

export default component.exports